// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jY7I","colMin":"styles_colMin__1LzjA"};